import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterlist'
})
export class FilterListPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!args) {
      return value;
    } else {
      return value.filter(
        (item: any) => (item.label && item.levelHeader === 'Location Level') ? item.label.toLowerCase().indexOf(args.toLowerCase()) > -1
        : item
     );
    }
  }
}
